import { Divider } from 'antd';
import Descriptions from 'antd/lib/descriptions';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentData } from '../../../store/interestStorage';
import { RowMd, DescFullWidth } from '../../../styles';
import { formatPLN } from '../../../utils/helpers/formatNumber';

const { Item: DescItem } = Descriptions;

const DetailsInterestsIntro = ({
  assignedPayments,
  isClaimFromFulfilled,
  interestsSum,
  interestsSumCovered,
  interestsSumFulfilledCovered,
  interestsSumFulfilledOverall,
  interestsSumFulfilledUncovered,
  interestsSumUncovered,
}:{
  assignedPayments: PaymentData,
  isClaimFromFulfilled:boolean,
  interestsSum: number,
  interestsSumCovered: number,
  interestsSumFulfilledCovered: number,
  interestsSumFulfilledOverall: number,
  interestsSumFulfilledUncovered: number,
  interestsSumUncovered: number,
}) => {
  const { t } = useTranslation();
  if (_.isEmpty(assignedPayments)) return null;
  return (
    <>
      <Divider>{t('detailsInterestsIntro.title')}</Divider>
      <RowMd>
        <DescFullWidth layout="horizontal" bordered key="d">
          <DescItem label={t('detailsInterestsIntro.desc')} span={3} labelStyle={{ fontWeight: 700 }}>
            <div style={{ fontSize: 16 }}>
              <strong>
                {`${formatPLN(isClaimFromFulfilled ? (interestsSumUncovered + interestsSumFulfilledUncovered) : interestsSumUncovered)}`}
              </strong>
            </div>
          </DescItem>
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.unpaid')}
                {' '}
                <strong>{t('detailsInterestsIntro.claimed')}</strong>
              </>
)}
            span={3}
          >
            {isClaimFromFulfilled ? 'tak' : 'nie'}
          </DescItem>
        </DescFullWidth>
      </RowMd>
      <RowMd>
        <DescFullWidth layout="horizontal" bordered key="d">
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.amount')}
                {' '}
                <strong>{t('detailsInterestsIntro.satisfied')}</strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSumFulfilledOverall)}`}
            </strong>
          </DescItem>
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.amount')}
                {' '}
                <strong>{t('detailsInterestsIntro.satisfied')}</strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSumFulfilledCovered)}`}
            </strong>
          </DescItem>
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.unpaidInterest')}
                {' '}
                <strong>{t('detailsInterestsIntro.satisfied')}</strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSumFulfilledUncovered)}`}
            </strong>
          </DescItem>
        </DescFullWidth>
      </RowMd>
      <RowMd>
        <DescFullWidth layout="horizontal" bordered key="d">
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.amount')}
                {' '}
                <strong>
                  {t('detailsInterestsIntro.unsatisfied')}
                </strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSum)}`}
            </strong>
          </DescItem>
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.amount')}
                {' '}
                <strong>

                  {t('detailsInterestsIntro.unsatisfied')}
                </strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSumCovered)}`}
            </strong>
          </DescItem>
          <DescItem
            label={(
              <>
                {t('detailsInterestsIntro.unpaidInterest')}
                {' '}
                <strong>
                  {t('detailsInterestsIntro.unsatisfied')}
                </strong>
                {' '}
                {t('detailsInterestsIntro.part')}
              </>
)}
            span={3}
          >
            <strong>
              {`${formatPLN(interestsSumUncovered)}`}
            </strong>
          </DescItem>
        </DescFullWidth>
      </RowMd>
    </>
  );
};

export default DetailsInterestsIntro;